<template lang="pug">
  .section
    .form-col.large-24(v-if="legal_custody_person.active")
      label {{ legal_custody_person.name }}
      span.description(v-if="legal_custody_person.description")
        | {{ legal_custody_person.description }}
      table.versity-sports-table
        tbody
          tr
            td
              validation-provider(:rules="{ required: legal_custody_person.required }" v-slot="{ errors }" name="Legal Custody Name")
                span.required(v-if="legal_custody_person.required") *
                label(:class="{ error: errors[0] }") {{ t('app.registration.transfer_info.name') }}
                input(
                  type="text"
                  placeholder="Enter name"
                  v-model="varsity_info.legal_custody_data.name"
                  :class="{ error: errors.length }"
                )
            td
              validation-provider(:rules="{ required: legal_custody_person.required }" v-slot="{ errors }" name="Relationship")
                span.required(v-if="legal_custody_person.required") *
                label(:class="{ error: errors[0] }") {{ t('app.registration.transfer_info.relationship') }}
                select(
                  v-model="varsity_info.legal_custody_data.relationship"
                  :class="{ error: errors.length }"
                )
                  option(value="" disabled selected) {{ t('app.registration.transfer_info.select_relationship') }}
                  option(v-for="relation in relationships" :key="relation" :value="relation") {{ relation }}

    .form-col.large-24(v-if="get_people_participant_lived_with.active")
      label
        | {{ people_participant_lived_with.name }}
      span.description(v-if="legal_custody_person.description")
        | {{ people_participant_lived_with.description }}
      table.versity-sports-table
        tbody
          tr(v-for="(member, index) in varsity_info.household_members_data.household_members" :key="index")
            td
              validation-provider(
                :rules="{ required: index === 0 && required }"
                v-slot="{ errors }"
              )
                span.required(v-if="index === 0 && required") *
                label(:class="{ error: errors[0] }") {{ t('app.registration.transfer_info.name') }}
                input(
                  type="text"
                  v-model="member.name"
                  placeholder="Enter name"
                  :class="{ error: errors[0] }"
                )

            td
              validation-provider( 
                :rules="{ required: index === 0 && required }"
                v-slot="{ errors }"
              )
                span.required(v-if="index === 0 && required") *
                label(:class="{ error: errors[0] }") {{ t('app.registration.transfer_info.relationship') }}
                select(
                  v-model="member.relationship"
                  :class="{ error: errors[0] }"
                )
                  option(value="" disabled selected) {{ t('app.registration.transfer_info.select_relationship') }}
                  option(v-for="relation in relationships" :key="relation" :value="relation") {{ relation }}

            td
              a.cancel-button(
                v-if="index > 0"
                @click.prevent="removeMemberRow(index)"
                title="Remove"
              )
                span.icon-nested-remove
        tfoot
          tr
            td.add-more(colspan="2")
              span.icon-add-more
              span.add-more-text(v-if="enable_add_member" @click.prevent="addMemberRow")
                | {{ t('app.registration.transfer_info.add_more') }}
</template>
<script>
  export default {
  props: {
    varsity_info: {
      type: Object,
      required: true,
    },
    enable_add_member: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: true,
    },
    nested_fields: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      showErrors: false,
      relationships: [
        'Parent/Legal Guardian',
        'Participant/Self',
        'Sibling',
        'Athletic Director at Receiving School',
        'Assistant Athletic Director at Receiving School',
        'Administration at Receiving School',
        'Office Staff at Receiving School',
        'Other'
      ],
    };
  },
  computed: {
    people_participant_lived_with(){
      return this.nested_fields.find(field => field.uid === 'people_participant_lived_with') || {};
    },
    legal_custody_person() {
      return this.nested_fields.find(field => field.uid === 'legal_custody_person') || {};
    },
    get_people_participant_lived_with() {
      return this.nested_fields.find(field => field.uid === 'people_participant_lived_with') || {};
    },
  },
  mounted() {
    if (!this.varsity_info.household_members_data.household_members || this.varsity_info.household_members_data.household_members.length === 0) {
      this.$set(this.varsity_info.household_members_data, 'household_members', []);
      this.addMemberRow();
    }
  },
  methods: {
    addMemberRow() {
      const MAX_ROWS = 10;

      if (this.varsity_info.household_members_data.household_members.length >= MAX_ROWS) {
        this.enable_add_member = false;
        return;
      }

      this.varsity_info.household_members_data.household_members.push({ name: '', relationship: '' });
      this.showErrors = true;
    },
    removeMemberRow(index) {
      if (this.varsity_info.household_members_data.household_members.length <= 10) {
        this.enable_add_member = true;
      }
      this.varsity_info.household_members_data.household_members.splice(index, 1);
    },
  },
};
</script>
